import React, { useEffect } from 'react';
import useToggle from 'hooks/use-toggle';
import ReactDOM from 'react-dom';

type PortalProps = {
    children: React.ReactNode;
};

const Portal: React.FC<PortalProps> = ({ children }) => {
    const [isLoaded, setIsLoaded] = useToggle();

    useEffect(() => {
        setIsLoaded.setToggleState(true);
    }, [setIsLoaded]);

    if (!isLoaded) {
        return null;
    }

    return ReactDOM.createPortal(
        children,
        document.body
    );
};

export default Portal;
